var exports = {
  "O": "NotificationDot.module__dot___WVZCM2",
  "s": "NotificationDot.module__srOnly___WVZCM2",
};

module.exports = exports;
